import { useQuery } from 'react-query';
import { companyInProgressConsultationsQuery } from './useCompanyInProgressConsultations.query';
import { UseCompanyConsultationsResponse } from '../useCompanyConsultations/useCompanyConsultations.types';
import { PageQueryParams } from '../../../types/api/api.types';

export const ALL_COMPANY_IN_PROGRESS_CONSULTATIONS_QUERY_KEY =
  'ALL_COMPANY_IN_PROGRESS_CONSULTATIONS';

export const useCompanyInProgressConsultations = (params: PageQueryParams) => {
  return useQuery<UseCompanyConsultationsResponse, Error>(
    ALL_COMPANY_IN_PROGRESS_CONSULTATIONS_QUERY_KEY,
    () => companyInProgressConsultationsQuery(params),
    {
      retry: false,
    }
  );
};
